import { ElevateApps } from '@amzn/elevate-graphql/types';

export const ElevateAppLabels = {
  [ElevateApps.INTERVIEW_MANAGEMENT]: 'Interview management',
  [ElevateApps.QUESTION_BANK]: 'Question bank',
  [ElevateApps.NONE]: 'Elevate',
  [ElevateApps.PROMOHUB]: 'PromoHub',
} as const satisfies Record<ElevateApps, string>;
